(function () {
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  document.querySelectorAll('[data-dp-predictive-search]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-dp-search-input]');
    var results = wrap.querySelector('[data-dp-predictive-results]');
    var backdrop = wrap.querySelector('[data-dp-predictive-backdrop]');
    if (backdrop) {
      document.body.appendChild(backdrop);
    }
    var form = wrap.querySelector('[data-dp-search-form]');
    if (!input || !results || !form) return;

    function closeResults() {
      results.hidden = true;
      results.innerHTML = '';
      if (backdrop) backdrop.classList.remove('is-open');
    }

    function renderResults(products, query) {
      if (!products.length) {
        results.innerHTML = '<div class="dp-predictive-results__empty">Sin resultados para “' + query + '”</div>';
        results.hidden = false;
        return;
      }
      var html = products.map(function (p) {
        return '<a href="' + p.url + '" class="dp-predictive-results__item">' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
          '<span><span class="dp-predictive-results__title">' + p.title + '</span>' +
          '<span class="dp-predictive-results__price">' + p.price + '</span></span></a>';
      }).join('');
      html += '<a href="/search?q=' + encodeURIComponent(query + '*') + '" class="dp-predictive-results__viewall">Ver todos los resultados</a>';
      results.innerHTML = html;
      results.hidden = false;
      if (backdrop) backdrop.classList.add('is-open');
    }

    var fetchSuggestions = debounce(function (query) {
      if (query.length < 2) { closeResults(); return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          var mapped = products.map(function (p) {
            return {
              url: p.url,
              title: p.title,
              image: p.featured_image ? p.featured_image.url : (p.image || ''),
              price: p.price_max ? p.price_max : (p.price || ''),
            };
          });
          renderResults(mapped, query);
        })
        .catch(function () { closeResults(); });
    }, 250);

    input.addEventListener('input', function () {
      fetchSuggestions(input.value.trim());
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) closeResults();
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.innerHTML) results.hidden = false;
    });

    // al enviar el formulario, forzar coincidencia parcial (comodín) para que "creat" encuentre "Creatina"
    form.addEventListener('submit', function () {
      var val = input.value.trim();
      if (val && val.indexOf('*') === -1) {
        input.value = val + '*';
      }
    });
  });
})();